/**
 * Jobs are tagged by the surface used to log them (Slice: job_context).
 * Route board matching uses REGULAR only; Opening/Closing/On-demand tabs use their own value.
 */

export const JOB_CONTEXT = {
  REGULAR: 'regular',
  OPENING: 'opening',
  CLOSING: 'closing',
  ON_DEMAND: 'on_demand',
  OFF_SEASON: 'off_season',
};

/** Whether a job row counts for a given surface (null/legacy treated as regular for route). */
export function jobMatchesContext(job, context) {
  if (context === JOB_CONTEXT.REGULAR) {
    return job?.job_context == null || job.job_context === JOB_CONTEXT.REGULAR;
  }
  return job?.job_context === context;
}

/** Sanitize navigation state before insert (unknown → regular). */
export function normalizeIncomingJobContext(raw) {
  const allowed = new Set(Object.values(JOB_CONTEXT));
  if (raw == null || raw === '') return JOB_CONTEXT.REGULAR;
  const v = String(raw);
  return allowed.has(v) ? v : JOB_CONTEXT.REGULAR;
}

/**
 * Lifecycle-aware resolution of job_context for a logged visit. The customer's
 * lifecycle_status overrides whatever surface the user came in through, so
 * an opening customer's jobs are always opening (and therefore correctly
 * bundled by the lifecycle-billing trigger), regardless of which entry point
 * the worker used. Mirrors the existing closed→off_season precedent.
 *
 * Single source of truth — call from every job-insert site.
 *
 * @param {string|null|undefined} incomingContext - whatever the surface passed
 * @param {{ lifecycle_status?: string } | null | undefined} customer
 * @returns {string} one of JOB_CONTEXT values
 */
export function resolveJobContextForCustomer(incomingContext, customer) {
  const lifecycle = customer?.lifecycle_status;
  if (lifecycle === 'closed')  return JOB_CONTEXT.OFF_SEASON;
  if (lifecycle === 'opening') return JOB_CONTEXT.OPENING;
  if (lifecycle === 'closing') return JOB_CONTEXT.CLOSING;
  return normalizeIncomingJobContext(incomingContext);
}
